module.exports = __webpack_public_path__ + "img/left-arm_hover.3e89eb21.png";